<template>
  <div>
    <p class="description">カテゴリを選んでください</p>
    <ul class="categoryList">
      <li v-for="category in categories" @click="clickCategory(category)" :key="category.id">
        <router-link tag="button" class="btn btn-secondary btn-block" :to="'./' + category.id + '/'">
          {{ category.name }}
          ({{ category.items_count }})
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'Category',
    components: {},
    data () {
      return {
        categories: []
      };
    },
    computed: {},
    methods: {
      clickCategory () {
      },
      async fetch () {
        this.$store.commit('setLoading');
        let response = await axios.get('http://admin.harigu.com/api/categories')
        this.categories = response.data;
        this.$store.commit('resetLoading');
      }
    },
    created () {
      this.fetch();
    }
  };
</script>

<style scoped lang="scss">
  ul.categoryList {
    padding: 0;
    li {
      position: relative;
      list-style-type: none!important;
      padding: 0.5em 0.5em 0.5em 0.5em;
      line-height: 1.5;
      vertical-align: middle;
      .btn {
        width: 70%;
        margin: 0 auto;
      }
    }
  }
  p.description {
    padding: 1rem .6rem;
    margin: 0;
  }
</style>
